import { render, staticRenderFns } from "./SuperAdminRegistrationForm.vue?vue&type=template&id=cc697c4e&scoped=true&"
import script from "./SuperAdminRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./SuperAdminRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminRegistrationForm.vue?vue&type=style&index=0&id=cc697c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc697c4e",
  null
  
)

export default component.exports